// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__7HBTI","col":"styles_col__ja6n6"};